// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2t3PE","largestCol":"styles_largestCol__1TgZW","smallestCol":"styles_smallestCol__V9r2z"};